import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import {scrollToggleFixed} from '../../utils/scrollFixedNav';
import {iniciarContadorDesdeFechaBase, iniciarContadorEvitadoDesdeFechaBase} from '../../utils/counter-kilos.js';

document.addEventListener('DOMContentLoaded', function ()
{

    scrollToggleFixed({
        navSelector: '#navbar',
        targetSelector: '#hero',
    });

    const swiperProcesos = new Swiper('.swiper-procesos', {
        loop: true,
        slidesPerView: 1,
        autoplay: true,
        speed: 2000,
        navigation: {
            prevEl: '.swiper-button-prev-procesos',
            nextEl: '.swiper-button-next-procesos',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
        },
    });

    const swiperPorque = new Swiper('.swiper-porque', {
        loop: true,
        slidesPerView: 4,
        // autoplay: true,
        // speed: 3000,
        navigation: {
            prevEl: '.swiper-button-prev-porque',
            nextEl: '.swiper-button-next-porque',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 25,
            },
            1920: {
                slidesPerView: 4,
                spaceBetween: 35,
            },
        },
    });

    const swiperAtributos = new Swiper('.swiper-atributos', {
        loop: true,
        slidesPerView: 1,
        // autoplay: true,
        // speed: 3000,
        navigation: {
            prevEl: '.swiper-button-prev-atributos',
            nextEl: '.swiper-button-next-atributos',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                spaceBetween: 15,
            },
            1280: {
                spaceBetween: 0,
            },
            1920: {
                spaceBetween: 0,
            },
        },
    });

    iniciarContadorDesdeFechaBase();
    iniciarContadorEvitadoDesdeFechaBase()
});
